module.exports = __webpack_public_path__ + "img/password-secure.34c421f3.svg";